import VConsole from "vconsole";
import Application from "./application.js";

let vConsole = null;

if (Application.debug === true) {
    vConsole = new VConsole();
}

export default vConsole;